module.exports = __webpack_public_path__ + "files/farizon.7542e9a715c3319f0e5f36b4fe74bc43.pdf";